var render, staticRenderFns
import script from "./TrainingsList.vue?vue&type=script&lang=js"
export * from "./TrainingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777adb3c')) {
      api.createRecord('777adb3c', component.options)
    } else {
      api.reload('777adb3c', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/TrainingsList.vue"
export default component.exports